import axios from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const apiIndicadoresFinancieros = (query) => axios.get(`${api}/indicadores-financieros`, { params: { ...query } })

export {
  apiIndicadoresFinancieros
}
